import { render, staticRenderFns } from "./PopProductsTable.vue?vue&type=template&id=2ea68c85&"
import script from "./PopProductsTable.vue?vue&type=script&lang=js&"
export * from "./PopProductsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports